import { CommonModule, NgIf } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { CheckBoxDirective, KENDO_INPUTS, KENDO_TEXTAREA, TextAreaDirective, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { LabelDirective } from '@progress/kendo-angular-label'
import { ToastrService } from 'ngx-toastr'
import { Subscription } from 'rxjs'
import { TasksAndMarketingService } from '../../../@theme/services/tasksAndMarketing.service'
import { TypesServices } from '../../../@theme/services/typeslist.service'
import { UserService } from '../../../@theme/services/user.service'

@Component({
  selector: 'gd-marketing-editor',
  templateUrl: './marketing-editor.component.html',
  styleUrls: ['./marketing-editor.component.scss'],
  imports: [
    CommonModule,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    LabelDirective,
    DatePickerComponent,
    DropDownListComponent,
    KENDO_INPUTS,
    KENDO_TEXTAREA,
    TextBoxDirective,
    TextAreaDirective,
    CheckBoxDirective,
    ButtonComponent,
  ]
})
export class MarketingEditorComponent implements OnInit {
  @Input() marketingId: number
  public marketingEditItem: any = null

  public marketingForm: UntypedFormGroup
  public editMarketingItem: any
  public selectedReportTypeSettings: any
  // Data
  public marketingTypes: any[]
  public marketingEntityTypes: any[]
  public marketingDistributionMethodTypes: any[]
  public marketingDistributionQuantityTypes: any[]
  public marketingStatusTypes: any[]
  public userList: string[]

  public sub: Subscription

  public canUpdateStatus = true

  constructor(
    private formBuilder: UntypedFormBuilder,
    private typesService: TypesServices,
    private userService: UserService,
    private marketingService: TasksAndMarketingService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit() {
    this.typesService.getMarketingTypes().subscribe((response) => {
      this.marketingTypes = response
    })
    this.typesService.getMarketingEntityTypes().subscribe((response) => {
      this.marketingEntityTypes = response
    })
    this.typesService
      .getMarketingDistributionMethodTypes()
      .subscribe((response) => {
        this.marketingDistributionMethodTypes = response
      })
    this.typesService
      .getMarketingDistributionQuantityTypes()
      .subscribe((response) => {
        this.marketingDistributionQuantityTypes = response
      })
    this.typesService.getMarketingStatusTypes().subscribe((response) => {
      this.marketingStatusTypes = response
    })
    this.userService.getUserEmailList().subscribe((response) => {
      this.userList = response
    })
    if (this.marketingId) {
      this.marketingService
        .getMarketingItem({ marketingId: this.marketingId })
        .subscribe((response) => {
          this.marketingEditItem = response
          this.canUpdateStatus =
            this.marketingEditItem.marketingStatusTypeId !== 2
          this.initForm()
        })
    } else {
      this.initForm()
    }
  }

  formSubmit() {
    const marketing = this.marketingForm.value
    const duration = 5000
    const preventDuplicates = true
    this.marketingService
      .submitMarketingUpdate(marketing)
      .subscribe((response) => {
        this.toastrService.success(response, null, {
        })
      })
  }

  initForm() {
    const editItem = this.marketingEditItem
    this.marketingForm = this.formBuilder.group({
      marketingId: editItem?.marketingId ?? 0,
      marketingStatusTypeId: editItem?.marketingStatusTypeId ?? 1,
      reportDate: editItem?.reportDate
        ? new Date(editItem.reportDate)
        : this.getDefaultReportDate(),
      marketingTypeId: [editItem?.marketingTypeId, Validators.required],
      submitDate: editItem?.submitDate ? new Date(editItem.submitDate) : null,
      submittedBy: editItem?.submittedBy,
      approveDateAdvisor: editItem?.approveDateAdvisor
        ? new Date(editItem.approveDateAdvisor)
        : null,
      approvedByAdvisorCco: editItem?.approvedByAdvisorCco,
      approvedByFundCco: editItem?.approvedByFundCco,
      approveDateFundCco: editItem?.approveDateFundCco
        ? new Date(editItem.approveDateFundCco)
        : null,
      approvedByFundDist: editItem?.approvedByFundDist,
      approveDateFundDist: editItem?.approveDateFundDist
        ? new Date(editItem.approveDateFundDist)
        : null,
      description: editItem?.description,
      assignedTo: editItem?.assignedTo,
      marketingEntityTypeId: editItem?.marketingEntityTypeId,
      performanceDataIncluded: editItem?.performanceDataIncluded ?? false,
      marketingDistributionMethodTypeId:
        editItem?.marketingDistributionMethodTypeId,
      marketingDistributionQuantityTypeId:
        editItem?.marketingDistributionQuantityTypeId,
      submittedToNasd: editItem?.submittedToNasd
        ? new Date(editItem.submittedToNasd)
        : null,
      dateOfFirstUse: editItem?.dateOfFirstUse
        ? new Date(editItem.dateOfFirstUse)
        : null,
    })
  }

  getDefaultReportDate(): Date {
    const today = new Date()
    const currentMonth = today.getMonth()
    const currentYear = today.getFullYear()

    if (currentMonth <= 3) {
      return new Date(`03/31/${currentYear}`)
    }
    if (currentMonth <= 6) {
      return new Date(`06/30/${currentYear}`)
    }
    if (currentMonth <= 9) {
      return new Date(`09/30/${currentYear}`)
    }
    return new Date(`12/31/${currentYear}`)
  }
}
